export default __webpack_public_path__ + "static/media/AAE-Fire-Fx-01.da22d405.jpg";